import config from '@/config'

export const relativeLink = (link) => {
  const relativeUrl = config.RELATIVE_URL_PATH
  return `${relativeUrl ? `/${relativeUrl}` : ''}${link}`
}

export const resourceLink = (link, page = null) => {
  const resourcesUrl = config.RESOURCES_DOMAIN_URL
  let compoundLink = `${resourcesUrl}${link}`
  if (page) {
    compoundLink += `#page=${page}`
  }
  return compoundLink
}

export const apiLink = (link) => {
  let compoundLink = `${config.API_DOMAIN_URL}${link}`
  return compoundLink
}

export default {
  relativeLink,
  resourceLink,
  apiLink,
}
